import axiosClient from '../axiosClient';

export const tagApi = {
  async getAllTag() {
    const url = 'customer/product-tags';
    return axiosClient.get(url);
  },
};
